// app/javascript/controllers/subscription_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "stateSelectWrapper", "stateTextWrapper", "zipcode"]

  change() {
    this.toggleStateField()
    this.toggleZipcodePattern()
  }

  toggleStateField() {
    const country = this.countryTarget.value
    const supportedCountries = ["US", "CA", "IN"]

    const stateSelectWrapperElement = $(`[data-subscription-target="stateSelectWrapper"]`)
    const stateTextWrapperElement = $(`[data-subscription-target="stateTextWrapper"]`)
    if (supportedCountries.includes(country)) {
      stateSelectWrapperElement.removeClass("hidden")
      stateTextWrapperElement.addClass("hidden")
      
      $('[data-subscription-target="stateSelectWrapper"] input').prop('required', true);
      $('[data-subscription-target="stateTextWrapper"] input').prop('required', false);
    } else {
      stateTextWrapperElement.removeClass("hidden")
      stateSelectWrapperElement.addClass("hidden")
      
      $('[data-subscription-target="stateTextWrapper"] input').prop('required', true);
      $('[data-subscription-target="stateSelectWrapper"] input').prop('required', false);
    }
  }

  toggleZipcodePattern() {
    const country = this.countryTarget.value
    const input = $('[data-subscription-target="zipcode"]')

    if (country === "US") {
      input.attr("pattern", "^[0-9]{5}(?:-[0-9]{4})?$")
    } else {
      input.removeAttr("pattern")
    }
  }
}
